export default {
      id: "230,1=1,7+70+60+70+28,4-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#230,1=1,7+70+60+70+28,4",
      toString: function () {
        return this.url;
      }
    }